import Logo from '~/components/common/Logo';
import MainNav from '~/components/navbar/MainNav';
import { useGetWarriors } from '~/hooks/useGetWarriors';

const WarriorList = () => {
  const { data: warriors } = useGetWarriors();

  return (
    <div className="container container--landing-page container--landing-page-warriors">
      <header className="landing-page__header">
        <MainNav showConnectWallet={false} />
      </header>
      <div
        className={`content-wrapper ${warriors ? '' : 'content-wrapper--full'}`}
      >
        <div className="landing-page__section--header">
          <Logo filename="warriors.svg" alt="Warrior List" />
        </div>
        <div className="landing-page__section--body">
          <div className="grid grid--seven">
            <div className="column column--first">
              {warriors?.map((warrior, i) => (
                <div className="grid__item" key={`names-col-${i}`}>
                  <div className="name">{warrior.name}</div>
                  <div className="nbr">{warrior.total}</div>
                </div>
              ))}
            </div>
            <div className="column">
              {warriors?.map((warrior, i) => (
                <div className="grid__item" key={`first-col-${i}`}>
                  <img
                    src={`/img/warriors/upgrades/${warrior.value.replace(
                      ' ',
                      '-'
                    )}/0.gif`}
                    alt={warrior.name}
                  />
                </div>
              ))}
              <p className="label">Level 1</p>
            </div>
            <div className="column">
              {warriors?.map((warrior, i) => (
                <div className="grid__item" key={`second-col-${i}`}>
                  <img
                    src={`/img/warriors/upgrades/${warrior.value.replace(
                      ' ',
                      '-'
                    )}/1.gif`}
                    alt={warrior.name}
                  />
                </div>
              ))}
              <p className="label">Level 2</p>
            </div>
            <div className="column">
              {warriors?.map((warrior, i) => (
                <div className="grid__item" key={`third-col-${i}`}>
                  <img
                    src={`/img/warriors/upgrades/${warrior.value.replace(
                      ' ',
                      '-'
                    )}/2.gif`}
                    alt={warrior.name}
                  />
                </div>
              ))}
              <p className="label">Level 3</p>
            </div>
            <div className="column">
              {warriors?.map((warrior, i) => (
                <div className="grid__item" key={`fourth-col-${i}`}>
                  <img
                    src={`/img/warriors/upgrades/${warrior.value.replace(
                      ' ',
                      '-'
                    )}/3.gif`}
                    alt={warrior.name}
                  />
                </div>
              ))}
              <p className="label">Level 4</p>
            </div>
            <div className="column">
              {warriors?.map((warrior, i) => (
                <div className="grid__item" key={`fifth-col-${i}`}>
                  <img
                    src={`/img/warriors/upgrades/${warrior.value.replace(
                      ' ',
                      '-'
                    )}/4.gif`}
                    alt={warrior.name}
                  />
                </div>
              ))}
              <p className="label">Level 5</p>
            </div>
            <div className="column">
              {warriors?.map((warrior, i) => (
                <div className="grid__item" key={`dead-col-${i}`}>
                  <img
                    src={`/img/defeated/${warrior.value.replace(' ', '-')}.gif`}
                    alt={warrior.name}
                  />
                </div>
              ))}
              <p className="label">Dead</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarriorList;
